import { Api } from '../../Api';
import { SettingsDailySettlementsDto } from './interfaces';
import { SettingsDailySettlementsPostBody } from './body';
import { SettingsDailySettlementsGetParams } from './params';
import { ListResult } from '@shared/api/interfaces';

export class DailySettlements {
    private static _basePath = '/Schedule';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${DailySettlements._basePath}`;
        return {
            async getCurrent() {
                const path = '/status';
                return await Api.get<SettingsDailySettlementsDto>({
                    path: `${basePath}${path}`,
                });
            },
            async get(query: SettingsDailySettlementsGetParams) {
                const path = '/history';
                return await Api.get<ListResult<SettingsDailySettlementsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async post(body: SettingsDailySettlementsPostBody) {
                const path = '/';
                return await Api.post<void>({
                    path: `${basePath}${path}`,
                    body,
                });
            },
        };
    }
}
